import logo from "./logo.svg";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useState, useEffect, Component } from "react";
import Nav from "./components/nav";
import Body from "./components/body";
import Footer from "./components/footer";
import Blog from "./components/Blog";
import CardDetail from "./components/cardDetail";
import Download from "./components/download";
import Careers from "./components/careers";
import CareerSingle from "./components/careerDetails";
import Payment from "./components/paymenttypes";
import AboutUs from "./components/about us";
import Leadership from "./components/Leadership";
import Ourbranch from "./components/OurBranch";
import Rsa from './components/rsa';
import Avc from './components/avc';
import Mp from './components/mp';
import Cbs from './components/cbs';
import NSITF from './components/nsitf';
import Mf from './components/managedFunds';
import Pms from './components/pms';
import Rma from './components/rma';
import Group from './components/groupLife';
import Credit from './components/credit';
import Withdrawal from './components/withdrawal';
import CSR from './components/csr';
import FAQ from './components/faq';
import Invest from './components/invest';
import Whistle from './components/whistleblowing';
import Privacy from './components/privacy';
import Funds from './components/funds';
import History from './components/history';
import Calculator from './components/calculator';
import FinancialReport from "./components/financial-report";
import Gallery from "./components/gallery";


import "./App.css";

function App() {


  return (
    <Router>
      <Nav />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/download" element={<Download />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/blog-single/:id" element={<CardDetail />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/our-branch-network" element={<Ourbranch />} />
         <Route path="/gallery" element={<Gallery />} />
        <Route path="/services/payment-types" element={<Payment />} />
        <Route path="/products/rsa" element={<Rsa />} />
        <Route path="/products/avc" element={<Avc />} />
        <Route path="/products/micro-pensions" element={<Mp />} />
        <Route path="/products/cross-border-services" element={<Cbs />} />
        <Route path="/products/managed-funds" element={<Mf />} />
        <Route path="/products/personal-messaging-service" element={<Pms />} />
        <Route path="/products/residential-mortgage-access" element={<Rma />} />
        <Route path="/services/group-life" element={<Group />} />
        <Route path="/services/unpaid-credit" element={<Credit />} />
        <Route path="/services/withdrawal" element={<Withdrawal />} />
        <Route path="/corporate-responsibility" element={<CSR />} />
        <Route path="/frequently-asked-questions" element={<FAQ />} />
        <Route path="/invest" element={<Invest />} />
        <Route path="/whistle-blower" element={<Whistle />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/fund-price" element={<Funds />} />
        <Route path="/fund-price/history" element={<History />} />
        <Route path="/fund-price/history/:fund" element={<History />} />
        <Route path="/calculator" element={<Calculator />} />
        <Route path="/financial-reports" element={<FinancialReport />} />
        <Route path="/Careers" element={<Careers />} />
          <Route path="/career-single/:id" element={<CareerSingle />} />
        <Route path="/services/nsitf" element={<NSITF />} />
        
    
      </Routes>

    </Router>
  );
}

export default App;
